import { Directive, Host, Input, Self } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BillingPlanTier } from '@recruitee/products-types';
import { IconColorDirective, IconToken } from '@recruitee/user-interface';
import { LifeCycle } from '@recruitee/utils';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { GuardedFeature } from '../feature-guard.types';

@Directive({
  selector: '[rtFeaturePlanIconColor]',
  standalone: true,
})
export class FeaturePlanIconColorDirective {
  @Input('rtFeaturePlanIconColor') public feature: GuardedFeature;
  @LifeCycle('onDestroy') private onDestroy$: Subject<void>;

  constructor(
    @Host() @Self() private iconColorDir: IconColorDirective,
    private guardFacade: FeatureGuardFacade,
  ) {
    if (!iconColorDir) throw new Error('Must be applied with IconColorDirective');
  }

  public ngAfterViewInit() {
    this.guardFacade
      .getPlanWhereFeatureIsAvailable(this.feature)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(plan => {
        this.iconColorDir.colorToken = this.getIconColor(plan);
      });
  }

  private getIconColor(plan: BillingPlanTier | null): IconToken {
    switch (plan) {
      case BillingPlanTier.Scale:
        return 'colorIconScaleDefault';
      case BillingPlanTier.Grow:
        return 'colorIconGrowDefault';
      case BillingPlanTier.Optimize:
        return 'colorIconOptimizeDefault';
      case BillingPlanTier.Lead:
        return 'colorIconLeadDefault';
      default:
        return 'colorIconDefault';
    }
  }
}
